module.exports = __webpack_public_path__ + "media/img/home/directions/list-2-45a74bf0f6ccef43370b7e5a8381c233.svg";